import { useSelector } from 'react-redux';

import type {
  MediaItem,
  ProductMediaState,
} from 'src/components/organisms/ProductMediaCarousel/types';
import { selectFavouriteProduct } from 'src/redux/favourites/selectors';
import { selectProduct, selectProductMedia } from 'src/redux/product/selectors';
import { selectCurrentMedia, selectNavigatedBy } from 'src/redux/productMediaCarousel/selectors';

/**
 * View model for the product media carousel. Owns the image, video,
 * favourite and carousel-position reads, so the carousel takes props and
 * its interaction handlers come from useProductMediaCarouselActions alongside.
 */
export interface ProductMediaViewModel {
  currentMedia: ProductMediaState['currentMedia'];
  favouriteProduct: boolean;
  media: MediaItem[];
  navigatedBy: ProductMediaState['navigatedBy'];
  productCode: number;
}

export const useProductMediaViewModel = (): ProductMediaViewModel => {
  const product = useSelector(selectProduct);
  const media = useSelector(selectProductMedia);
  const favouriteProduct = useSelector(selectFavouriteProduct);
  const currentMedia = useSelector(selectCurrentMedia);
  const navigatedBy = useSelector(selectNavigatedBy);

  return {
    currentMedia,
    favouriteProduct,
    media,
    navigatedBy,
    productCode: product.code,
  };
};
